import React,{ useState, useEffect, useCallback } from 'react';
import { useSelector,  connect} from 'react-redux';
import moment from 'moment';
import { Divider, Loader } from 'rsuite';
import * as actionsPolicy  from '../../../../app/actions/policy';
import {fetchLocationsByDistrict}  from '../../../../app/common/services/fetch.service';
import {findPlateCodeByDistrictName, findLocationCode, getPlateFirstLetters}  from '../../../../app/common/services/vehicle.service';
import { NuInsInputNumLabel, NuInsSelectLabel, NuInsInputDateLabel } from '../elements/inputFieldsLabel';
import NuInsStepper from '../elements/NuInsStepper';
import NuInsToggle from '../elements/NuInsToggle';
import {steppLabels} from './common/types';
import {practiceYearsType} from '../../../../app/common/types/vehicleTypes';
import {BackIcon} from '../svg/iconsSvg';
import {FrameIcon} from '../svg/iconFrameSvg';

const locationOptionsMap = (data) => {
    if(!data?.length) return [];
    let options = data.map(data => data.name);
    options.sort((a, b) => a.localeCompare(b));
    options = options.filter((value, index, self) => self.indexOf(value) === index);

    return options.map(name => ({label: name, value: name, role: "Master"}));
}

//..........Component Start...............

const QuestionnaireOwner = ({onBack, onForward, updateQuestionsPolicy, getDistricts, 
                            changeLocation, getInsOffersForCompany, clearInsOffers, style}) => {

    const insCompanies = useSelector(state => state.insCompanies);
    const { offers } = useSelector(state => state.insOffers);
    
    const {districts, location, initialData} = useSelector(state => state.insVehicleInfo);
    const {locationName, districtName} = location || {};
    const {plate} = initialData || {};

    const questions = useSelector(state => state.questionsPolicy);
    const {ownerType, driversAge, driverYearsOfPractice, commenceDate} = questions;

    const [districtData, setDistrictData] = useState({districtOptions: [], districtName: null});
    const [locationData, setLocationData] = useState({locationOptions: [], locationName: null, districtLocations: null});
    const [yearsOfPracticeData, setYearsOfPracticeData] = useState({yearsOfPracticeOptions: [], yearsOfPractice: null});
    const [commenceDateValue, setCommenceDateValue] = useState(null);

    const [submitted, setSubmitted] = useState(false);
    const [initialized, setInitialized] = useState(false);
    const [loading, setLoading] = useState(false);

    const tomorow = moment().add(1, 'd').format("YYYY-MM-DD");
    const maxDateAvailable = moment().add(45, 'd').format("YYYY-MM-DD");

    useEffect(() => {
        if(!ownerType) {
            updateQuestionsPolicy({ownerType: '0'});
        }
    }, [ownerType, updateQuestionsPolicy]);



    const updateDistrictData = useCallback(() => {
        let options =  districts.map(district => district.districtName).sort((a, b) => a.localeCompare(b));
        options = options.map(districtName => ({label: districtName, value: districtName, role: "Master"}) );
        setDistrictData({districtName, districtOptions: options});
    // this is only for registered vehicles 
        if(!initialized && districts && districtName) {
            const plateFirstLetters = plate ? getPlateFirstLetters(plate) : findPlateCodeByDistrictName(districts, districtName);

            setLoading(true);
            fetchLocationsByDistrict(plateFirstLetters).then(
                res => {
                    if(res.data) {
                        const options = locationOptionsMap(res.data);
                        setLocationData({locationOptions: options, locationName, districtLocations: res.data});
                        setLoading(false);
                    }
                    setLoading(false);
                },
                error => {console.log(error); setLoading(false);}
            );
            setInitialized(true);
        }

    }, [districtName, districts, initialized, locationName, plate]);

    useEffect(() => {
        if (!districts) {
            setLoading(true)
            getDistricts();
        } else if (!initialized) {
            setLoading(false);
            updateDistrictData()
        }
     //   console.log(districts)
    },[ getDistricts, updateDistrictData, districts, initialized]);

    const updateLocationOptions = (districtName) => {
        const plateCode = findPlateCodeByDistrictName(districts, districtName);
        setLocationData({locationOptions:[], locationName: null, districtLocations: null});
        changeLocation(null); //updates Redux store

        setLoading(true)

        fetchLocationsByDistrict(plateCode).then(
            res => {
                if(res.data) {
                  //  console.log(res.data);
                    const options = locationOptionsMap(res.data);
                    setLocationData({locationOptions: options, locationName: null, districtLocations: res.data});
                    changeLocation({locationCode: null, districtName, locationName: null}); //updates Redux store
                    setLoading(false);
                }
            },
            error => {console.log(error); setLoading(false);}
        );
    };

    const updateLocation = (name) => {
        setLocationData({...locationData, locationName: name});
        const locationCode = findLocationCode(locationData.districtLocations, name);
        changeLocation({locationCode, districtName, locationName: name});
    }

    const updateInitialYearsOfPractice = useCallback(() => {
        const options = Object.keys(practiceYearsType).map(key => ({label: key, value: practiceYearsType[key], role: "Master"}));
        if(!yearsOfPracticeData.yearsOfPractice) {
            setYearsOfPracticeData({yearsOfPracticeOptions: options, yearsOfPractice: practiceYearsType['5 години']});
            updateQuestionsPolicy({driverYearsOfPractice: practiceYearsType['5 години']});
           // console.log('testYearsofP')
        }
    }, [yearsOfPracticeData, updateQuestionsPolicy]);

    useEffect(() => {
        updateInitialYearsOfPractice();
    }, [updateInitialYearsOfPractice]);

    const updateCommenceDate = useCallback(() => {
        let startDate = null;
        const existingDate = commenceDate ? moment(commenceDate) : moment();
        if(existingDate.isAfter(moment())) {
            startDate = existingDate.format('YYYY-MM-DD');
        } else {
            // This is removed, to force the owner to pick a date, not to use the default one
           // startDate = moment().add(1, 'd').format('YYYY-MM-DD');
        }
        
        setCommenceDateValue(startDate);
        updateQuestionsPolicy({commenceDate: startDate});
      //  console.log('startDate', startDate)
    },[commenceDate, updateQuestionsPolicy]);

    useEffect(() => {
        updateCommenceDate();
    }, [updateCommenceDate]);

    const changeHandler = (field, data) => {
       //    console.log('data', data)
            switch (field) {
                case 'ownerType':
                    return updateQuestionsPolicy({ownerType: data ? '1' : '0'});
                case 'districtSelected':
                    return updateLocationOptions(data);
                case 'locationSelected':
                    return updateLocation(data);
                case 'driversAge':
                    return updateQuestionsPolicy({driversAge: data});
                case 'driverYearsOfPractice':   
                    data = data !== '0' ? data : '1'; 
                    setYearsOfPracticeData({...yearsOfPracticeData, yearsOfPractice: data});
                    return updateQuestionsPolicy({driverYearsOfPractice: data});
                case 'commenceDate': 
                    data = data.format('YYYY-MM-DD');
                    return updateQuestionsPolicy({commenceDate: data});
                default:
                    return 'Unknown stepIndex';
            }
        }

    const checkValidity = () => {
     //   console.log(ownerType, locationName, districtName, driversAge, driverYearsOfPractice, commenceDate)
    // console.log(questions)
        return ownerType && locationName && districtName && driversAge && driverYearsOfPractice && commenceDate ;
    }

    const getInsOffers = (insCompanies) => {
        if (!insCompanies) return;

        insCompanies.forEach(company => {
            getInsOffersForCompany(company);
        });
    };

    const submitHandler = () => {
        setSubmitted(true)
        if(!checkValidity()) return;

    // console.log(questions)
    //To Do add validation for ....
        if(Object.keys(offers)) {
            clearInsOffers(insCompanies);

            setTimeout(() => {
                getInsOffers(insCompanies)
                onForward(6);
            }, 0)
        } else {
            getInsOffers(insCompanies)
            onForward(6);
        }

    }

    const goBack = () => {
        onBack(3); //to be determined
    }

    const errorMsg = "Полето е задължително";

    return (
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <div className="head-icon" style={{margin: '0 -8px 0 4px'}} onClick={goBack}><BackIcon size={32}/></div>
                <NuInsStepper activeStep={1} steps={4} labels={steppLabels}/>              
            </div>
            <Divider />
            <div className="big-icon-container" style={{marginBottom: '20px'}}>
                <FrameIcon />
            </div>
  
            <div className="steps_container-form show-loading" >
                <h6 className="text-label" style={{paddingLeft: '5px'}}>Собственик</h6>
                <NuInsToggle onChange={(data)=>changeHandler('ownerType', data)} textLeft="физическо лице" textRight="юридическо лице"/>

                <NuInsSelectLabel onChange={(data) => changeHandler('districtSelected', data)} placeholder={"Област"} options={districtData.districtOptions} 
                                  value={districtData.districtName} error={submitted && !districtName ? true : false} errorMsg={errorMsg}
                                  styles={{marginBottom: '20px', marginTop: '20px'}}/>
              
                <NuInsSelectLabel onChange={(data)=>changeHandler('locationSelected', data)} placeholder={"Населено място по талон"} 
                                  options={locationData.locationOptions} value={locationData.locationName} 
                                  disabled={!locationData.locationOptions?.length} error={submitted && !locationName ? true : false} 
                                  errorMsg={errorMsg} styles={{marginBottom: '18px'}}/>

                <NuInsInputNumLabel validationType={"noZero"} slice={3} onChange={(data)=>changeHandler('driversAge', data)} 
                                    placeholder={ownerType === '0' ? "Възраст на собственика по талон" : "Възраст на обичайния водач"} value={driversAge}  
                                    error={submitted && !driversAge ? true : false} errorMsg={errorMsg}
                                    styles={{marginBottom: '20px'}}/>
           
                <NuInsSelectLabel onChange={(data)=>changeHandler('driverYearsOfPractice', data)} placeholder={"Шофьорски стаж"} 
                                  options={yearsOfPracticeData.yearsOfPracticeOptions} value={yearsOfPracticeData.yearsOfPractice} 
                                  error={submitted && !driverYearsOfPractice ? true : false} errorMsg={errorMsg}
                                  styles={{marginBottom: '20px'}}/>
          
                <NuInsInputDateLabel onChange={(data)=>changeHandler('commenceDate', data)} 
                                    placeholder={"Начална дата на застраховката"} value={commenceDateValue} 
                                    error={submitted && !commenceDate ? true : false} errorMsg={errorMsg}
                                    minDate={tomorow} maxDate={maxDateAvailable}/>
                <p className="secondary-text">Най-ранната дата, която можеш да избереш, е денят след последния ден на валидната застраховка </p>
         
                <button className="nuIns-btn nuIns-btn-mxd nuIns-btn-main" type="button" disabled={false} onClick={submitHandler}>Продължи</button>

            </div>
            {loading ? <Loader backdrop center size="lg"  speed="slow" /> : null}
        </div>
    )
}

export default connect(null, {...actionsPolicy})(QuestionnaireOwner);